module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/tunnel-high-cube-mobile-9f127e496af163b20b7fc3d310a65f3e.png";